import { ComponentProps, ComponentRegistry } from '@enonic/react-components';
import React, { type FC, type JSX } from 'react';

import { Page } from './pages/page/Page';

import { OneColumn } from './layouts/oneColumn/OneColumn';

import { Breadcrumbs } from '@dip/helsecore/src/components/parts/Breadcrumbs/Breadcrumbs';

import { AlertBanner } from './parts/alertBanner/AlertBanner';
import { AlertList } from '/react4xp/parts/alertList/AlertList';
import { ButtonBanner } from '/react4xp/parts/buttonBanner/ButtonBanner';
import { FeaturedArticles } from '/react4xp/parts/featuredArticles/FeaturedArticles';
import { InfoAccordions } from '/react4xp/parts/infoAccordions/InfoAccordions';
import { InfoBanner } from '/react4xp/parts/infoBanner/InfoBanner';
import { InfoLinkCards } from '/react4xp/parts/infoLinkCards/InfoLinkCards';
import { NotificationFormAnonymous } from './parts/notificationFormAnonymous/NotificationFormAnonymous';
import { NotificationFormServices } from './parts/notificationFormServices/NotificationFormServices';
import { PageTop } from "/react4xp/parts/pageTop/PageTop";
import { ShowArticle } from "/react4xp/parts/showArticle/ShowArticle";


interface IntoxicantComponentData {
	category?: string;
	intoxicant: string;
}


const TRACE = false;


function Intoxicant(props: ComponentProps): JSX.Element {
	if (TRACE) console.debug('Props', JSON.stringify(props, null, 4));
	const {
		category,
		intoxicant,
	} = props.data as unknown as IntoxicantComponentData;
	return (
		<section>
			<h1>Rusmiddel: {intoxicant}</h1>
			<h2>Kategori: {category || 'Ikke valgt!'}</h2>
		</section>
	);
}


function GenericView(props: ComponentProps): JSX.Element {
	return (
		<div>{JSON.stringify(props, null, 4)}</div>
	);
}


const LegacyPart = <LegacyProps extends object>(LegacyPartComponent: FC<LegacyProps>) =>
	(decoratedProps: { data: LegacyProps }): JSX.Element => {
		const { data: legacyProps } = decoratedProps;
		return (
			<LegacyPartComponent {...legacyProps}/>
		);
	};


export const componentRegistry = new ComponentRegistry();
// componentRegistry.addContentType('base:folder', { View: GenericView });
// componentRegistry.addContentType('media:image', { View: GenericView });
// componentRegistry.addContentType('media:vector', { View: GenericView });
// componentRegistry.addContentType('portal:page-template', { View: GenericView });
// componentRegistry.addContentType('portal:site', { View: Page });
// componentRegistry.addContentType('portal:template-folder', { View: GenericView });

// componentRegistry.addContentType('overdosefare:alert', { View: GenericView });
// componentRegistry.addContentType('overdosefare:article-new', { View: GenericView });

componentRegistry.addContentType('overdosefare:intoxicant', { View: Intoxicant });
// componentRegistry.addContentType('overdosefare:intoxicant-category', { View: GenericView });

componentRegistry.addPage('overdosefare:index', { View: Page });

componentRegistry.addLayout('overdosefare:helsecoreOneColumn', { View: OneColumn });

componentRegistry.addPart('overdosefare:alert-banner', { View: AlertBanner });
componentRegistry.addPart('overdosefare:alert-list', { View: LegacyPart(AlertList) });
componentRegistry.addPart('overdosefare:button-banner', { View: LegacyPart(ButtonBanner) });
componentRegistry.addPart('overdosefare:featured-articles', { View: LegacyPart(FeaturedArticles) });

componentRegistry.addPart('overdosefare:helsecoreAccordion', { View: GenericView });
componentRegistry.addPart('overdosefare:helsecoreArticleBody', { View: GenericView });
componentRegistry.addPart('overdosefare:helsecoreArticleTop', { View: GenericView });
componentRegistry.addPart('overdosefare:helsecoreBreadcrumbs', { View: LegacyPart(Breadcrumbs) });
componentRegistry.addPart('overdosefare:helsecoreLinkbox', { View: GenericView });

componentRegistry.addPart('overdosefare:info-accordions', { View: LegacyPart(InfoAccordions) });
componentRegistry.addPart('overdosefare:info-banner', { View: LegacyPart(InfoBanner) });
componentRegistry.addPart('overdosefare:info-link-cards', { View: LegacyPart(InfoLinkCards) });
componentRegistry.addPart('overdosefare:notificationFormAnonymous', { View: NotificationFormAnonymous });
componentRegistry.addPart('overdosefare:notificationFormServices', { View: NotificationFormServices });
componentRegistry.addPart('overdosefare:page-top', { View: LegacyPart(PageTop) });
componentRegistry.addPart('overdosefare:show-article', { View: LegacyPart(ShowArticle) });
